import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Clock } from "lucide-react";
import api, { money } from "@/lib/api";
import { GALLERY } from "@/constants/media";
import { PageHero, Loading, Empty } from "@/components/site/ui";
import { Reveal } from "@/components/brand";

export default function Experiences() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/experiences").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div>
      <PageHero eyebrow="Stay & Social" title="The Experiences"
        subtitle="From a full-property takeover to an evening under the lights — choose how you spend your time at The D." />
      <div className="max-w-7xl mx-auto px-6 py-20">
        {items === null ? <Loading /> : items.length === 0 ? <Empty text="Experiences will appear here soon." /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((e, i) => (
              <Reveal key={e.id} delay={(i % 3) * 0.08}>
                <Link to={`/experiences/${e.id}`} data-testid={`exp-card-${e.id}`}
                  className="group block glass rounded-lg overflow-hidden hover:glow-gold transition-shadow duration-500 h-full">
                  <div className="h-56 overflow-hidden">
                    <img src={e.image || GALLERY[(i + 2) % GALLERY.length].src} alt={e.title}
                      className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-6">
                    <p className="text-[10px] tracking-label uppercase text-pool">{e.category}</p>
                    <h3 className="font-serif text-2xl mt-2">{e.title}</h3>
                    <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{e.short_desc}</p>
                    <div className="flex gap-4 mt-4 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1"><Users size={13} /> {e.capacity}</span>
                      <span className="flex items-center gap-1"><Clock size={13} /> per {e.unit}</span>
                    </div>
                    <div className="mt-5 flex items-center justify-between">
                      <span className="text-gold">{e.invitation_only ? "By Invitation" : `From ${money(e.base_price)}`}</span>
                      <ArrowRight size={16} className="text-gold group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
